import { navigator } from '../../../navigator'
import activator from '../../../activator'

import type Button from '../../Button/Button'

/**
 * A deaktiválás gombra kattintva ez hívódik meg.
 * @param e - A klikk esemény.
 */
export default function onClickDeactivate (e: Event): void {
  const btn = e.currentTarget as Button
  btn.disabled = true

  activator.deactivate(navigator.welcome)
}
